import React, { useState, useEffect } from "react";
import { Typography, Form, Button, Modal, Row, Col } from "antd";
import ChildrenAnimationWrapper from "../animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../animations/AnimationChildWrapper";
import { FormattedMessage } from "react-intl";
import { CloseOutlined } from "@ant-design/icons";
import { InputItem } from "../forms/FormItems";
import { SettingsDataSelect } from "../forms/AutoCompleteFormItem";
import { useDispatch, useSelector } from "react-redux";
import {
  FileImageOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileUnknownOutlined,
} from "@ant-design/icons";
import {
  loadPage,
  setChangedTimestamp,
} from "../../features/assets/assetsSlice";
import { setChangedFormItems } from "../../features/asset/assetSlice";
import moment from "moment";
import { getChangedItems } from "./helpers";

const { Title, Text } = Typography;
const AssetUploadModal = (props) => {
  const {
    visible,
    closeModal,
    mode,
    file,
    addAsset,
    updateAsset,
    branch_id,
    id,
    resource,
    activeRecord,
    scope,
    branchId,
  } = props;

  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const addLoading = useSelector((state) => state.pendingActions["asset/add"]);
  const { scopePrefix } = useSelector((state) => state.user);
  const updateLoading = useSelector(
    (state) => state.pendingActions["asset/update"]
  );
  const changedItems = useSelector((state) => state.asset.changedItems.changed);
  const [category, setCategory] = useState(null);
  const layout = {
    labelCol: { span: 9 },
    wrapperCol: { span: 15 },
  };

  useEffect(() => {
    if (mode === "edit" && activeRecord) {
      form.setFieldsValue(activeRecord);
      setCategory(activeRecord.category_id);
    }
  }, [activeRecord, mode]);

  const onSubmit = async (values) => {
    const scopePre = branchId
      ? `branches/${branchId}/${scope}`
      : `${scopePrefix}${scope}`;
    const params =
      mode === "edit"
        ? {
            id: activeRecord.id,
            allValues: values,
            scope: scopePre,
          }
        : {
            branchId: branch_id,
            id: id,
            assetName: file.fileName,
            file: file,
            params: { ...values, content_type: file.type },
            resource,
          };
    const action =
      mode === "edit"
        ? await dispatch(updateAsset(params))
        : await dispatch(addAsset(params));
    if (!action.error) {
      await dispatch(loadPage({ current: 1, filter: { freeText: "" } }));
      await dispatch(setChangedFormItems({ changed: [], values: [] }));
      await dispatch(setChangedTimestamp(moment().format()));
      closeModal();
      form.resetFields();
    }
  };

  const onValuesChange = (values, all) => {
    if (values.category_id || !all.category_id) {
      setCategory(values.category_id);
      form.setFieldsValue({ ...values, sub_category_id: null });
    }
    if (mode === "edit" && activeRecord) {
      const arr = getChangedItems(values, all, changedItems, activeRecord);
      dispatch(setChangedFormItems({ changed: arr, values: all }));
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onCancel = () => {
    closeModal();
  };

  const isImage = file && file["type"].includes("image");
  const isPdf = file && file["type"].includes("pdf");
  const isDoc = file && file["type"].includes("msword");

  const filterByResource = (items) => {
    let data = [];
    if (resource) {
      const filtered = items.filter((i) => i.owner_type === resource);
      data = filtered;
    }
    return data;
  };

  const filterSubCategories = (items) => {
    let data = [];
    if (category) {
      const filtered = items.filter((i) => i.parent_category_id === category);
      data = filtered;
    }
    return data;
  };
  const disabled =
    (mode === "edit" && !activeRecord) || (mode !== "edit" && !file);
  return (
    <Modal
      closable={false}
      footer={null}
      maskClosable={false}
      title={null}
      width={"fit-content"}
      styles={{
        body: {
          padding: 0,
        },
      }}
      open={visible}
      destroyOnClose={true}
    >
      <div>
        <div className="header" style={{ height: "40px" }}>
          <Button
            style={{ position: "absolute", left: 10, top: 10 }}
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={onCancel}
          />
        </div>
        <Title
          style={{
            fontSize: "30px",
            fontWeight: 500,
            lineHeight: 1.27,
            color: "rgba(0, 0, 0, 0.85)",
            margin: "13px 0 40px 0 ",
            textAlign: "center",
          }}
        >
          {mode === "edit" ? (
            <FormattedMessage id="app.assets.update_title" />
          ) : (
            <FormattedMessage id="app.assets.upload_title" />
          )}
        </Title>

        <Form
          {...layout}
          onFinish={onSubmit}
          onFinishFailed={onFinishFailed}
          form={form}
          style={{
            padding: "0 128px 0px 128px",
            width: "600px",
          }}
          onValuesChange={onValuesChange}
        >
          <ChildrenAnimationWrapper>
            <Row>
              <Col key={1} span={24} style={{ padding: "0 20px" }}>
                <AnimationChildWrapper key={1} itemKey={1}>
                  <div
                    className="fileDetails"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      alignSelf: "center",
                      paddingRight: "37%",
                      paddingBottom: "10px",
                    }}
                  >
                    {isImage ? (
                      <FileImageOutlined style={{ color: "#5850ec" }} />
                    ) : isPdf ? (
                      <FilePdfOutlined style={{ color: "#5850ec" }} />
                    ) : isDoc ? (
                      <FileWordOutlined style={{ color: "#5850ec" }} />
                    ) : (
                      <FileUnknownOutlined style={{ color: "#5850ec" }} />
                    )}
                    <Text style={{ padding: "0 5px" }}>
                      {file && file.fileName}
                    </Text>
                  </div>
                </AnimationChildWrapper>

                <AnimationChildWrapper key={2} itemKey={2}>
                  <InputItem
                    name={"name"}
                    category={"assets"}
                    required={true}
                  />
                </AnimationChildWrapper>
                <AnimationChildWrapper key={3} itemKey={3}>
                  <SettingsDataSelect
                    name="category_id"
                    category="assets"
                    settingsdataName={"system_tables/asset_categories"}
                    required={true}
                    filterItems={filterByResource}
                  />
                </AnimationChildWrapper>
                <AnimationChildWrapper key={4} itemKey={4}>
                  <SettingsDataSelect
                    name="sub_category_id"
                    category="assets"
                    settingsdataName={"system_tables/asset_sub_categories"}
                    required={true}
                    filterItems={filterSubCategories}
                  />
                </AnimationChildWrapper>
                {mode === "edit" && (
                  <AnimationChildWrapper key={5} itemKey={5}>
                    <SettingsDataSelect
                      name="status_id"
                      category="assets"
                      settingsdataName={"system_tables/asset_statuses"}
                      required={true}
                      filterItems={filterByResource}
                    />
                  </AnimationChildWrapper>
                )}
              </Col>
              <Row style={{ width: "100%" }}>
                <div
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <Form.Item wrapperCol={{ span: 24 }}>
                    <Button
                      style={{ minWidth: "100px" }}
                      size="large"
                      type="primary"
                      htmlType="submit"
                      loading={addLoading || updateLoading}
                      disabled={disabled}
                    >
                      {mode === "edit" ? (
                        <FormattedMessage id="app.actions.update_asset" />
                      ) : (
                        <FormattedMessage id="app.actions.upload_asset" />
                      )}
                    </Button>
                  </Form.Item>
                </div>
              </Row>
            </Row>
          </ChildrenAnimationWrapper>
        </Form>
      </div>
    </Modal>
  );
};

export default AssetUploadModal;
